export default __webpack_public_path__ + "static/image/image002.f208b51a.jpg";